export default "__VITE_ASSET__c9e2ce39__"